<div class="wrap">
  <main class="main-section">
    <header>
      <multisite-main-navigation
        [user]="user()"
        [logo]="'interculturalist'"
        [navLinks]="mainNavigationLinks"
        (changeSidenavMode)="changeSidenavMode(null)"
        (logout)="logout()"
        [loading]="loading"
        [sidenavMode]="sidenavMode"
        >
      </multisite-main-navigation>
    </header>
    <!-- Announcements, directly below the navigation -->
    <multisite-announcement-banner></multisite-announcement-banner>
    <multisite-breadcrumb></multisite-breadcrumb>

    <section>
      <router-outlet></router-outlet>
    </section>

    <footer>
      <multisite-footer [logo]="'interculturalist'" [summaryTranslationKey]="'about_summary'"></multisite-footer>
    </footer>
  </main>
  <!-- <div style="width: 360px;" class="sticky-top"> -->

  @if (user()) {
    <multisite-sidenav
      [user]="user()"
      [mode]="sidenavMode"
      (logout)="logout()"
      (changeMode)="changeSidenavMode($event)"
    ></multisite-sidenav>
  }
<!-- </div> -->
</div>